export const getColorFromTheme = ({ palette }, colorEnum) => {
    if (colorEnum === 'primary' || colorEnum === 'secondary') {
        return palette[colorEnum].main;
    }
    return palette[colorEnum];
};
